import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CategoryModel, CategoryMoviesModel } from '../interfaces/category.model';

@Injectable({
  providedIn: 'root',
})
export class CategoriesService {
  baseUrl = `${environment.apiEndpoint}/Category`;

  constructor(private http: HttpClient) { }

  getCategoriesMovies(): Observable<CategoryMoviesModel[]> {
    return this.http.get<CategoryMoviesModel[]>(`${this.baseUrl}/GetAllWithMovies`);
  }

  getCategoryByIdWithMovies(idMovie: number): Observable<CategoryMoviesModel> {
    return this.http.get<CategoryMoviesModel>(`${this.baseUrl}/GetByIdWithMovies?Id=` + idMovie);
  }

  getAllCategories(): Observable<CategoryModel[]> {
    return this.http.get<CategoryModel[]>(`${this.baseUrl}`);
  }

  getAllCategoriesForHome(): Observable<CategoryModel[]> {
    return this.http.get<CategoryModel[]>(`${this.baseUrl}/GetAllForHome`);
  }

  getWithMoviesInRange(from: number, take: number): Observable<CategoryMoviesModel[]> {
    return this.http.get<CategoryMoviesModel[]>(`${this.baseUrl}/GetWithMoviesInRange?from=` + from + `&take=` + take);
  }

  GetWithMoviesInRangeHome(from: number, take: number): Observable<CategoryMoviesModel[]> {
    return this.http.get<CategoryMoviesModel[]>(`${this.baseUrl}/GetWithMoviesInRangeHome?from=` + from + `&take=` + take);
  }

  GetSpecialSectionMovies(): Observable<CategoryMoviesModel[]> {
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${JSON.parse(localStorage.getItem('cinemateca_token'))['token']}`,
    ).set('sectionToken',
      `${localStorage.getItem('cinemateca_cafToken')}`);


    // const headers.set('sectionToken', `${localStorage.getItem('cinemateca_cafToken')}`);

    //return this.http.get<MovieLinkInfoModel>(`${this.baseUrl}/GetMovieLinkInfo`, { params, headers });

    return this.http.get<CategoryMoviesModel[]>(`${this.baseUrl}/GetSpecialSectionMovies`, { headers, });
  }

  //Felix Oliver
  getCategoriesMoviesFelixOliver(): Observable<CategoryMoviesModel[]> {
    return this.http.get<CategoryMoviesModel[]>(`${this.baseUrl}/GetAllFOWithMovies`);
  }

  //Felix Oliver
  GetFeaturedMoviesFelixOliver(): Observable<CategoryMoviesModel[]> {
    return this.http.get<CategoryMoviesModel[]>(`${this.baseUrl}/GetFeaturedMoviesFO`);
  }

}
